import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';
import L from 'leaflet';
import 'leaflet-extra-markers';


const statusObject = {
    0: {
        color: 'red',
        description: 'fail'
    },
    1: {
        color: 'green',
        description: 'active'
    },
    2: {
        color: 'purple',
        description: 'init'
    },
    3: {
        color: 'orange',
        description: 'error'
    },
}

const UniqueGatewayMap = ({ center, zoom = 13, pointer, status}) => {
    const mainMarkerIcon = L.ExtraMarkers.icon({
        markerColor: statusObject[status].color,
        shape: 'circle',
        prefix: 'fa',
    });

    return (
        <MapContainer
            attributionControl={false}
            center={center}
            zoom={zoom}
            style={{ height: '500px', width: '100%', zIndex: 0 }}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {/* Main Marker */}
            <Marker position={[pointer.latitude, pointer.longitude]} icon={mainMarkerIcon}>
                {/* <Popup>Name: {pointer.name}</Popup> */}
            </Marker>

        </MapContainer>
    );
};

export default UniqueGatewayMap;